/*
 * Accepts two arrays and returns an array of values that are present in both arrays.
 */
export const intersection = (arr1: Array<number | string>, arr2: Array<number | string>) => {
  let i = 0;
  let res = [];
  while (i < arr1.length) {
    const value = arr1[i];
    if ((typeof value === 'number' || typeof value === 'string') && arr2.includes(value)) {
      res.push(value);
    }
    i++;
  }
  return res;
};
